module.exports = __webpack_public_path__ + "static/media/ajax-Loader.6748875e.gif";